import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store/index'

const request = axios.create({
  baseURL: 'https://siyuan.renlianiot.com/api',
  // baseURL: 'http://127.0.0.1:8000/api',
  timeout: 200000,
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0
  })
  const token = store.getters.token
  if (token) {
    config.headers['Access-Token'] = token
    config.headers.platform = 'H5'
  }
  let userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
  config.params = { ...config.params, openid: localStorage.getItem('openid') ? localStorage.getItem('openid') : '', uid: userinfo.userId ? userinfo.userId : '' }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  const res = response.data
  console.log('res', res)
  if (res.code !== 10000) {
    Toast(res.message)
    // return Promise.reject(res.message)
  } else {
    Toast.clear()
  }
  return res
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default request
